function AppFooter(p){
    return(<footer className="footer">footer{p.children}</footer>);
}

export default AppFooter